import * as React from "react";

import {
  IList,
  IListLine
} from "../api/lists.api";

interface IListProductsProps {
  list: IList;
  ListProductLine: (listLine: IListLine) => React.ReactNode;
}

const ListProducts: React.ReactFCWithChildren<IListProductsProps> = ({ list, ListProductLine }) => {
  return (
    <>
      {list.listLines.length > 0 && list.listLines.map(listLine => ListProductLine(listLine))}
    </>
  );
};

export default ListProducts;
